import React from 'react'

const Console = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='800px'
    height='800px'
    viewBox='0 0 76 76'
    version='1.1'
    baseProfile='full'
    enableBackground='new 0 0 76.00 76.00'
    xmlSpace='preserve'
    {...props}
  >
    <path
      fill='#000000'
      fillOpacity='1'
      strokeWidth='0.2'
      strokeLinejoin='round'
      d='M 17,20L 59,20L 59,56L 17,56L 17,20 Z M 20,26L 20,53L 56,53L 56,26L 20,26 Z M 23.75,31L 28.5,31L 33.25,37.5L 28.5,44L 23.75,44L 28.5,37.5L 23.75,31 Z '
    />
  </svg>
)

export default Console
